import React, { useMemo } from 'react';
import { Grid, GridRow, GridColumn, useBreakpoint } from '@axiom/ui';
import type {
  Account,
  FullCandidateAccount,
  Taxonomy,
  User,
} from '@axiom/validation';

import { MyBenchCard } from '../MyBenchCard/MyBenchCard';

import { MyBenchEmpty } from './MyBenchEmpty';

export type MyBenchItemGridProps = {
  name?: string;
  candidates: FullCandidateAccount[];
  user: User;
  account: Account;
  isEnvoyUser?: boolean;
  taxonomy: Taxonomy;
};

type RowColumnDataType = MyBenchItemGridProps['candidates'];

export const MyBenchGrid = ({
  candidates,
  user,
  account,
  isEnvoyUser,
  taxonomy,
}: MyBenchItemGridProps) => {
  const { isMobile } = useBreakpoint();
  const columnCount = isMobile ? 1 : 3;

  const rowData = useMemo(() => {
    const ary = [...candidates];
    const count = Math.ceil(ary.length / columnCount);
    const data: RowColumnDataType[] = [];

    if (count) {
      for (let i = 0; i < count; i++) {
        const bits = ary.splice(0, columnCount);

        data.push(bits);
      }
    }

    return data;
  }, [candidates, columnCount]);

  return rowData.length > 0 ? (
    <Grid stackable name="TALENT_GRID">
      {rowData.map(columnData => {
        return (
          <GridRow
            name="GRID_ROW"
            columns={columnCount}
            stretched
            gutterBottom="24px"
            key={columnData[0]?.id}
          >
            {columnData.map(candidate => {
              return (
                <GridColumn name="GRID_COLUMN" key={candidate.id} stretched>
                  <MyBenchCard
                    name="CANDIDATE_CARD"
                    candidate={candidate}
                    user={user}
                    isEnvoyUser={isEnvoyUser}
                    account={account}
                    taxonomy={taxonomy}
                  />
                </GridColumn>
              );
            })}
          </GridRow>
        );
      })}
    </Grid>
  ) : (
    <MyBenchEmpty account={account} user={user} />
  );
};
